import { Box, styled } from '@mui/material';

interface DotProps {
  color: string;
  showMargin?: boolean;
}

const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'showMargin',
})<DotProps>(({ theme, color, showMargin }) => ({
  width: 6,
  height: 6,
  borderRadius: '50%',
  backgroundColor: color,
  marginLeft: showMargin ? theme.spacing(1) : undefined,
}));

export default Dot;
